import { _ as f } from "../../../VHeadline.vue_vue_type_script_lang-186a5340.js";
import h from "../VIcon/VIcon.js";
import b from "../VText/VText.js";
import { S as w } from "../../../Spacing-695d3b19.js";
import { a as y } from "../../../vee-validate.esm-c4518011.js";
import { defineComponent as S, computed as V, resolveComponent as l, openBlock as r, createElementBlock as _, Fragment as v, createElementVNode as n, normalizeClass as k, createVNode as C, createBlock as d, withCtx as $, createTextVNode as F, toDisplayString as I, createCommentVNode as s } from "vue";
import { _ as z } from "../../../_plugin-vue_export-helper-dad06003.js";
import "../../../composables/useShowPriceDisclaimer.js";
import "../../../composables/useSpacingClass.js";
import "../../../utils/tailwindUnitsConverter.js";
const B = S({
  name: "VFormRadioSolutionCard",
  components: {
    VHeadline: f,
    VIcon: h,
    VText: b
  },
  emits: ["change", "update:modelValue"],
  inheritAttrs: !1,
  props: {
    id: {
      type: String,
      default: ""
    },
    header: {
      type: String,
      default: ""
    },
    subline: {
      type: String,
      default: ""
    },
    value: {
      type: String,
      default: ""
    },
    modelValue: {
      type: [String, Boolean],
      default: ""
    },
    name: {
      type: String,
      default: ""
    },
    type: {
      type: String,
      default: "radio"
    },
    rules: {
      type: Function,
      default: () => !0
    }
  },
  setup(e, t) {
    const { handleChange: o } = y(e.name, e.rules, {
      validateOnMount: !1,
      uncheckedValue: "",
      type: e.type,
      valueProp: e.value
    });
    return o(e.modelValue), {
      handleChange: o,
      onChange: (a) => {
        let i = a.target.value;
        a.target.checked || (i = ""), o(i), t.emit("change", a);
      },
      Spacing: w,
      profileImg: `https://assets.live.app.obi.de/web-assets/advice/${e.value}-planner.png`,
      isSelected: V(
        () => Array.isArray(e.modelValue) ? e.modelValue.includes(e.value) : e.modelValue === e.value
      )
    };
  }
});
const N = ["type", "id", "name", "value", "v-model", "checked", "aria-describedby"], T = ["for"], A = ["src"], H = { class: "tw-flex tw-flex-col tw-justify-center tw-m-1" };
function R(e, t, o, c, a, i) {
  const m = l("VHeadline"), u = l("VText"), p = l("VIcon");
  return r(), _(v, null, [
    n("input", {
      type: e.type,
      id: e.id,
      name: e.name,
      value: e.value,
      "v-model": e.modelValue,
      checked: e.isSelected,
      class: "hobi-visually-hidden hobi-input",
      "aria-describedby": `hobi-${e.name}-error-message`,
      onChange: t[0] || (t[0] = (...g) => e.onChange && e.onChange(...g))
    }, null, 40, N),
    n("label", {
      for: e.id,
      class: k(["hobi-solution-picker tw-flex tw-relative tw-overflow-hidden tw-h-18 tw-mb-4 tw-rounded tw-border tw-border-solid tw-border-gray-300", {
        "hobi-solution-picker__selected tw-border-2 tw-border-solid tw-border-orange": e.isSelected
      }])
    }, [
      n("img", {
        src: e.profileImg,
        class: "hobi-solution-picker__profile-picture tw-mx-0.5 tw-mb-0",
        height: "152"
      }, null, 8, A),
      n("div", H, [
        C(m, {
          as: "span",
          title: e.header,
          size: "xxs",
          bottomSpacing: e.Spacing.s,
          topSpacing: e.Spacing.s
        }, null, 8, ["title", "bottomSpacing", "topSpacing"]),
        e.isSelected ? (r(), d(u, {
          key: 0,
          size: "m",
          bottomSpacing: e.Spacing.s
        }, {
          default: $(() => [
            F(I(e.subline), 1)
          ]),
          _: 1
        }, 8, ["bottomSpacing"])) : s("", !0),
        e.isSelected ? (r(), d(p, {
          key: 1,
          size: "16px",
          symbol: "checkmark",
          class: "hobi-solution-picker__checkbox tw-absolute tw--top-0 tw--right-0 tw-bg-orange tw-text-white tw-rounded-bl tw-text-center"
        })) : s("", !0)
      ])
    ], 10, T)
  ], 64);
}
const K = /* @__PURE__ */ z(B, [["render", R], ["__scopeId", "data-v-00ef0f6c"]]);
export {
  K as default
};
